import builder from '../builder';
import LockCircle from '../../streamline-icons/light/lock-circle.svg';

export default builder('IconLockCircleLight', LockCircle);
